import { render, staticRenderFns } from "./FlagsSelector.vue?vue&type=template&id=5c033b50"
import script from "./FlagsSelector.vue?vue&type=script&lang=ts"
export * from "./FlagsSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports